import env from './utils/env'

export const API = () => {
  const request = env.get('config').request
  const { username } = env.get('options') || {}
  const setComs = params => {
    return {
      ...params,
      uid: username,
    }
  }
  return {
    // 反馈列表
    getFeedbackList(params) {
      return request
        .post({
          url: 'spacex.spacex.feedback.list',
          params: setComs(params),
        })
        .then(res => {
          console.log(res)
          return res.data
        })
        .catch(error => console.error(error))
    },
    // 反馈详情
    getFeedbackDetail(params) {
      return request
        .post({
          url: 'spacex.spacex.feedback.detail',
          params: setComs(params),
        })
        .then(res => {
          console.log(res)
          return res.data
        })
        .catch(error => console.error(error))
    },
    // 创建反馈
    createFeedback(params) {
      return request
        .post({
          url: 'spacex.spacex.feedback.create',
          params: setComs(params),
        })
        .then(res => {
          console.log(res)
          return res.data
        })
    },
    // 获取产品模块
    getProductModule(params) {
      return request
        .post({
          url: 'spacex.msg.template.module',
          params: setComs(params),
        })
        .then(res => {
          console.log(res)
          return res.data
        })
        .catch(error => console.error(error))
    },
    // 城市/大区列表
    getArea(params) {
      return request
        .get({
          url: 'common.getMultiCityList',
          params,
        })
        .then(res => res.data)
        .catch(error => console.error(error))
    },
    // 国家列表
    getAuthCountry(params) {
      return request
        .get({
          url: 'common.getUserAuthCountry',
          params,
        })
        .then(res => res.data)
        .catch(error => console.error(error))
    },
  }
}
